import axiosInstance from "../../../interceptor/intercetptor-inctence";
import { secureApiFormDataRequest, secureApiRequest } from "../../../Services/secureApiRequest";


export const listAPI = (data) => {
    return axiosInstance.post(`clinic_admin/clinic_users`, data);
}

export const createAPI = (data) => {
    return axiosInstance.post(`clinic_admin/clinic_users/create`, data);
}

export const getData = (id) => {
    return axiosInstance.get(`clinic_admin/clinic_users/get/${id}`);
}

export const updateAPI = (data) => {
    return axiosInstance.post(`clinic_admin/clinic_users/update`, data);
}

export const doctorsMaster = () => {
    return axiosInstance.get(`masters/doctors`)
}
export const getProfile = () => {
    // return axiosInstance.get(`clinic_admin/profile`)
    return secureApiRequest("get", `clinic_admin/profile`)
}
export const updateProfile = (data, files) => {
    // return axiosInstance.post(`clinic_admin/profile/update`, data)
    return secureApiFormDataRequest("post", `clinic_admin/profile/update`, data, files)
}

export const getPharmacyProfile = (data) => {
    return axiosInstance.post('/healthcare_providers/auth/getProfile', data)
}

export const updatePharmacyProfile = (data) => {
    return axiosInstance.post('/healthcare_providers/auth/updateProfile', data)
}

export const getConversionRates = () => {
    return axiosInstance.post('/healthcare_providers/auth/getRates','')
}